import * as HTML from './HTML'
import Ant from './Ant'
import Demo from './Demos/Demo'
export default {
	...HTML,
	...Ant,
	Demo
}
